export { default } from "./AccountCreatedConfirmation";
